import React, {useState} from 'react'
import {Col, Form, Input, message, Upload} from "antd";
import {Field} from "./index";
import Utils from "../../utils";
import {QuestionCircleOutlined, UploadOutlined} from "@ant-design/icons";
import {LabelWithTooltip} from "./components/LabelWithTooltip";
import {FieldBase} from "./components/FieldBase";
import Button from "antd/es/button";
import {env} from "../../configs/EnvironmentConfig";

// Componente controlado: Form.Item (en FieldBase) le inyecta value/onChange.
// La lista mostrada se deriva siempre del valor del formulario, así no queda
// en memoria el fichero de otro formulario al reutilizar la instancia del form.
const FileUpload = ({value, onChange, endpoint}) => {
  // Solo guardamos en estado local el fichero mientras se está subiendo
  const [uploadingFile, setUploadingFile] = useState(null)
  const idProject = Utils.getIdProject()
  const idPatient = Utils.getPatientLocation()
  const apiEndpoint = endpoint || env.API_FILES
  const getFileUrl = (name) => name.startsWith("http") ? name : apiEndpoint+"/files/"+idProject+"/"+idPatient+"/"+name;

  const fileList = uploadingFile ? [uploadingFile] : value ? [{
    uid: '-1',
    name: value,
    status: 'done',
    url: getFileUrl(value)
  }] : []

  const props = {
    name: 'file',
    multiple: false,
    action: apiEndpoint+'/upload',
    onPreview: (file)=> {
      window.open(getFileUrl(file.name));
    },
    data: {
      patient:idPatient,
      project:idProject
    },
    fileList: fileList,
    onChange: (info) => {
      if (info.file.status === 'removed') {
        // Cuando se elimina el archivo
        setUploadingFile(null);
        onChange("");
        return;
      }
      if(info.file.status === "uploading") {
        setUploadingFile(info.file);
      }
      if(info.file.status === "done") {
        const serverFileName = info.file.response.filename;
        setUploadingFile(null);
        onChange(serverFileName);
        message.success(`${serverFileName} file uploaded successfully`);
      }
      if (info.file.status === 'error') {
        setUploadingFile(null);
        message.error(`${info.file.name} file upload failed.`);
      }
    },
  };
  return (
    <Upload {...props}>
      <Button>
        <UploadOutlined /> Adjuntar
      </Button>
    </Upload>
  )
}

export class FieldFile extends Field {

  constructor(obj={}) {
    super(obj);
  }



  getComponent (form) {

    return () => (
      <FieldBase condition={this.condition} form={form} size={this.size} label={this.label} name={this.name} value={this.value} help={this.help}>
        <FileUpload endpoint={this.endpoint}/>
      </FieldBase>
    );
  }

  transformToField = (data) => {
    this.name = data.name;
    this.label = data.label;
    this.type = data.type;
    this.size = data.size ?? 6;
    this.value = data.value ?? data.defaultValue ?? "";
    this.disabled = data.disabled ?? false;
    this.condition = data.condition ?? true;
    this.endpoint = data.endpoint; // Añadir la propiedad endpoint para URL personalizada
    
    this.help = data.help;
    return this;
  }
}